import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  Fade,
  Typography,
  Grid,
  Chip,
  Box,
} from '@mui/material';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import { useLocation } from 'react-router-dom';
import PageCenter from '../../templates/PageCenter/PageCenter';
import { LOGIN_CARD_STYLES } from '../../../constants';
import {
  selectConfig,
} from '../../../state/configs/configsSlice';

function DuplicateAudioDevice() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  // Get SIP device and active call data from location state (passed from saga)
  const { sipDevice, hasActiveCalls } = location.state || {};

  const wpName = useSelector((state) => selectConfig(state, 'PORTAL_WEB_PHONE_NAME')) || t('SNAPMOBILE_WEB');

  const handleUserAction = (actionType, action) => {
    dispatch({ type: actionType, payload: { action } });
  };

  // Build the notice string based on device and call status
  const titleSentence = hasActiveCalls ? t('ACTIVE_CALL_DETECTED') : t('DEVICE_ALREADY_REGISTERED');

  return (
    <PageCenter>
      <Fade in>
        <Card sx={{ ...LOGIN_CARD_STYLES, pb: 0 }}>
          <CardContent>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {wpName}
              {' '}
              {titleSentence}
            </Typography>

            {sipDevice && hasActiveCalls && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <Chip
                  label={t('ACTIVE_CALLS')}
                  color="warning"
                  variant="outlined"
                />
              </Box>
            )}

            <Grid container direction="row" sx={{ mt: 2 }}>
              <Typography>
                {t('DEVICE_ALREADY_REGISTERED_MESSAGE', { wpName })}
              </Typography>
            </Grid>

            <Grid container direction="row" spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={hasActiveCalls ? 4 : 6}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => handleUserAction('DUPLICATE_AUDIO_DEVICE_CONTINUE', 'continue')}
                >
                  {t('CONTINUE')}
                </Button>
              </Grid>

              {false && hasActiveCalls && (
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => handleUserAction('DUPLICATE_AUDIO_DEVICE_TRANSFER_AUDIO', 'transferAudioHere')}
                  >
                    Transfer Audio Here
                  </Button>
                </Grid>
              )}

              <Grid item xs={hasActiveCalls ? 4 : 6}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => handleUserAction('DUPLICATE_AUDIO_DEVICE_RETURN_LOGIN', 'returnToLogin')}
                >
                  {t('RETURN_TO_LOGIN')}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Fade>
    </PageCenter>
  );
}

export default DuplicateAudioDevice;
